if($('.type-detail').length){
    var textFriends = '#kamaradi';

    if ($('table.detail-parameters tbody tr th').text().trim().includes(textFriends)) {

        var apiUrl = "https://friends.shopcode.cz/new/api-products.php";
        var section = "autojamar";
        var codes = [];

        $('table.detail-parameters tbody tr').each(function () {
            var headerText = $(this).find('th span.row-header-label').text().trim();
            var friendName = $(this).find('td').text().trim();

            if (headerText.includes(textFriends)) {
                $(this).closest('tr').hide();
                codes.push(friendName);
            }
        });

        if (codes.length === 0) {
            console.warn("Žádné hodnoty " + textFriends + " nebyly nalezeny.");
        } else {

            $.ajax({
                url: apiUrl,
                type: "GET",
                data: {
                    section: section,
                    codes: getShoptetDataLayer('product').codes[0].code
                },
                dataType: "json",
                success: function (response) {
            
                    const productCode = String(getShoptetDataLayer('product').codes[0].code);

                    const itemData = response.result.find(i => String(i.code) === productCode);

                    if (!itemData) {
                        console.warn("Nenalezen objekt pro CODE:", productCode);
                        return;
                    }

                    const alternatives = itemData.alternatives || [];

                    if (!alternatives.length) {
                        console.warn("Nenalezeni kamaradi produktu.");
                        return;
                    }
                    
                    function compareByKamaradi(a, b) {
                        const aVal = (a.KAMARADI_HODNOTY || '').toString().toLowerCase().trim();
                        const bVal = (b.KAMARADI_HODNOTY || '').toString().toLowerCase().trim();

                        return aVal.localeCompare(bVal, 'cs', { numeric: true, sensitivity: 'base' });
                    }

                    // hlavní kamarád
                    const mainAlt = alternatives.find(a => a.is_main) || alternatives[0];
                    
                    $(".p-data-wrapper .p-variants-block").after(`
                        <div class="friendsSection">
                            <div class="h6">Všechny varianty:</div>
                            <div class="inner"></div>
                        </div>
                    `);

                    // řazení podle speciální logiky
                    alternatives
                        .filter(item => !item.VISIBILITY || item.VISIBILITY.toLowerCase() !== "hidden")
                        .sort(compareByKamaradi)
                        .forEach(function (item) {

                            var nameEscaped = escapeHtmlAttr(item.NAME);

                            var customClass = (item.URL && document.location.pathname === item.URL.replace(/^https?:\/\/[^\/]+/, ''))
                                ? 'active'
                                : '';

                            var imageUrl = (item.IMAGE && item.IMAGE.trim())
                                ? item.IMAGE
                                : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/big.png';

                            var imageWrapper = item.URL
                                ? `<a href="${item.URL}"><img src="${imageUrl}" alt="${nameEscaped}"></a>`
                                : `<span><img src="${imageUrl}" alt="${nameEscaped}"></span>`;

                            var detailHtml = `
                                <div class="friend ${customClass} show-tooltip" data-title="${nameEscaped}" data-original-title="${nameEscaped}">
                                    <div class="p">
                                        <div class="image">${imageWrapper}</div>
                                        <div class="name">${item.KAMARADI_HODNOTY}</div>
                                    </div>
                                </div>
                            `;

                            $(".p-data-wrapper .friendsSection .inner").append(detailHtml);
                        });
                },
                error: function (xhr, status, error) {
                    console.error("Chyba při volání API:", error);
                }
            }).done(function () {
                initTooltips();
            });
        }

        function escapeHtmlAttr(text) {
            return text
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        }
    }
}